import React, { Component } from 'react';
import { Button } from 'reactstrap';
import Loader from '../../components/Loader';
import Header from '../../components/Header';
import AlertsList from '../../components/AlertsList';
import AlertModal from '../../components/AlertModal';

import './AlertsPage.css';

export default class AlertsPage extends Component {

  constructor(props){
    super(props);
    window.page = this;
  }

  componentDidMount(){
    setInterval(this.refresh, 60 * 1000);
  }

  handleAddAlertClick = (e) => {
    window.page.modal.show();
  }

  handleModalSave = (e) => {
    this.refresh();
  }

  refresh(){
    window.page.list.loadAlerts();
  }

  render() {
    return (
      <div className="alerts-page">
        <Loader />
        <Header />
        <div className="container">
          <Button className="mt20" color="secondary" onClick={this.handleAddAlertClick}>+ add</Button>
          <AlertsList/>
          <AlertModal onSave={this.handleModalSave}/>
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/routes/analytics/AlertsPage.js